import React, { useEffect, useRef, useState } from 'react';
import { ChatMessage, LoaderContext, renderMessage } from '@chewy/chat-library-common';
import MessageStamp from './MessageStamp';
import { KibInlineAlert } from "@chewy/kib-messaging-react";
import '@chewy/kib-messaging-styles/dist/styles/kib-alert-icon.css';
import '@chewy/kib-messaging-styles/dist/styles/kib-inline-alert.css';
import styles from "./AiChatMessage.module.scss";

export interface AiChatMessageProps {
  message: ChatMessage;
  loaderContext?: LoaderContext;
  handleScroll?: (element: HTMLDivElement) => void;
}

export default function AiChatMessage({ message, loaderContext = undefined, handleScroll }: AiChatMessageProps) {
  const [renderedContent, setRenderedContent] = useState<React.ReactNode | null | undefined>(undefined);
  const containerRef = useRef<HTMLDivElement>(null);

  const isHumanMessage = message.responseType === 'user' || message.responseType === 'agent';
  const shouldShowStamp = isHumanMessage;

  useEffect(() => {
    const loadMessage = async () => {
      const content = await renderMessage(message, loaderContext ?? undefined);
      setRenderedContent(content ?? null);
    };

    loadMessage();
  }, [message, loaderContext]);

  useEffect(() => {
    if (handleScroll && renderedContent && containerRef.current) {
      handleScroll(containerRef.current);
    };
  }, [handleScroll, message.id, renderedContent]);

  return (
    <div ref={containerRef} data-testid={`chat-message-${message.responseType}`}>
      {!!renderedContent && (
        <>
          {shouldShowStamp && message.responseTimestamp && (
            <MessageStamp message={message} />
          )}
          {renderedContent}
        </>
      )}
      {message.error && <div className={styles.errors}>
        <KibInlineAlert severity="error">
          <span className={styles.alertContent}>{message.error}</span>
        </KibInlineAlert>
      </div>}
    </div>
  );
}
